import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import IndikatorsServices from "./indikators.services";
import GeneralInfoServices from "../GeneralInfo/GeneralInfo.services";

export const getIndikators = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_INDIKATORS,
      payload: true,
    });
    const resp = await IndikatorsServices.getIndikators(filters);
    dispatch({
      type: actions.GET_INDIKATORS,
      payload: resp.data,
    });
    dispatch({
      type: actions.INDIKATORS_FAIL,
      payload: null,
    });
    dispatch({
      type: actions.FORM_INDIKATORS_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.INDIKATORS_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_INDIKATORS,
      payload: false,
    });
  }
}

export const getIndikator = id => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_INDIKATOR,
      payload: true,
    });
    const resp = await IndikatorsServices.getIndikator(id);
    dispatch({
      type: actions.GET_INDIKATOR,
      payload: resp.data,
    });
    dispatch({
      type: actions.INDIKATOR_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.INDIKATOR_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_INDIKATOR,
      payload: false,
    });
  }
}

export const saveIndikator = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_INDIKATOR,
      payload: true,
    });
   
    const resp = await IndikatorsServices.saveIndikator(req);
    const { indikators } = getState().indikators;
    
    dispatch({
      type: actions.GET_INDIKATORS,
      payload: {
        count: indikators.count + 1,
        data: [...indikators.data, resp.data]
      },
    });

    dispatch({
      type: actions.FORM_INDIKATORS_FAIL,
      payload: null,
    });

    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });

    setShowModal(false);

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_INDIKATORS_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_INDIKATOR,
      payload: false,
    });
  }
}

export const editIndikator = (req, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_INDIKATOR,
      payload: true,
    });
    const resp = await IndikatorsServices.editIndikator(req.id, req);
    const { indikators } = getState().indikators;
    let _indikators = indikators.data.slice();
    const dataT = resp.data
    _indikators[index] = dataT;
    dispatch({
      type: actions.GET_INDIKATORS,
      payload: {
        count: indikators.count,
        data: _indikators
      },
    });
    dispatch({
      type: actions.FORM_INDIKATORS_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    setShowModal(false);
    const _data = {
      data:[
        {
          funcion_descriptor:dataT.list_descriptor[0].posicion,
          tipo_mensaje:"Jefe actualiza descriptor"
        }
      ]
    }
    await GeneralInfoServices.mailSendGeneralInfo(_data);
    toastr.success(messages.correoEnviado, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_INDIKATORS_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_INDIKATOR,
      payload: false,
    });
  }
}

export const deleteIndikator = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_INDIKATORS,
      payload: true,
    });
    await IndikatorsServices.deleteIndikator(id);
    const { indikators } = getState().indikators;
    let _indikators = indikators.data.slice();
    _indikators.splice(index, 1);
    dispatch({
      type: actions.GET_INDIKATORS,
      payload: {
        data: _indikators,
        count: indikators.count - 1
      }
    });
    dispatch({
      type: actions.INDIKATORS_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    // dispatch({
    //   type: actions.INDIKATORS_FAIL,
    //   payload: message
    // })
    toastr.error(message, '', {
      progressBar: true,
      rtl: true,
    });
  }finally {
    dispatch({
      type: actions.LOADER_INDIKATORS,
      payload: false,
    });
  }
}